<template>
  <div class="add-league level">
    <input v-model="league.en.title" type="text"
      placeholder="League title" class="input" />

    <input v-model="league.en.subtitle" type="text"
      placeholder="Subtitle" class="input" />

    <button v-on:click="add" class="button is-primary">
      Add new league
    </button>
  </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    data: function() {
      return {
        league: {
          languages: ["en"],
          en: {
            title: "",
            subtitle: "",
            countryLabel: "Country",
            ministerLabel: "Minister",
            quotaLabel: "Quota",
            quotaUnitLabel: "Tonnes",
            fishLabel: "Species fished above scientific advice"
          }
        }
      }
    },
    methods: {
      add: function() {
        var leagueRef = firebase.database().ref('leagues').push();
        this.league.createdAt = Date.now()
        leagueRef.set(this.league);
        console.log("Added league");
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** LeagueAdd.vue?1566a16e
 **/